import { useContext } from 'react';
import { isNil } from '../lib';

import { FormMethodsContext } from './FormContext.tsx';

function useFormMethodsContext() {
  const context = useContext(FormMethodsContext);
  if (import.meta.env.MODE === 'development' && isNil(context)) {
    throw new Error(
      'Context "FormMethodsContext" is not defined above components tree.',
    );
  }
  return context as NonNullable<typeof context>;
}

export default useFormMethodsContext;
